import React from 'react'
import CardElement from './CardElement'
import FileIcon from '../../../assets/icons/sidebar/file.svg'


function CustomerInvoice({ data }) {
  return (
    <div className='w-100'>
      {data.length > 0 ? (
        data.map((invoice, index) => (
          <CardElement key={index} data={invoice} page='invoice' title= 'Invoice' icon={FileIcon}/>
        ))
      ) : (
        // <CardElement data={{ status: 0 }} page='invoice' />
        <div>No Invoices</div>
      )}
    </div>
  )
}

export default CustomerInvoice
